import React from 'react';
import Slider from 'react-slick';
import { jsx, css } from '@emotion/core';
import { FaSpinner } from 'react-icons/fa';

import { primary_l50 } from '../lib/colors';
import lightOrDark from '../SlickArrow/colorArrowFunction';
import SlickArrow from '../SlickArrow/SlickArrow';

import './ItemSlider.scss';
import SlickArrowCirclePrimary from '../SlickArrow/SlickArrowCirclePrimary';
import SlickArrowCircleSecondary from '../SlickArrow/SlickArrowCircleSecondary';

const ItemSlider = ({
  loading,
  primaryColor,
  secondaryColor,
  uiVariant,
  children,
  fullWidth,
  sliderCircleArrowsProducts,
  productsCarouselVersion,
  productsThumbnail,
  parentName,
  ...props
}) => {
  const colorCheck = lightOrDark(secondaryColor);
  const productArrowsVariants = css`
    .slick-slider > .slick-arrow > span > svg {
      color: ${// sliderCircleArrowsProducts === 1 && colorCheck === 'dark'
      colorCheck === 'dark' ? '#ffff' : '#272F3C'};
      background-color: ${sliderCircleArrowsProducts === 1 &&
      productsThumbnail === 1
        ? secondaryColor
        : sliderCircleArrowsProducts === 1 && productsThumbnail === 2
        ? secondaryColor
        : sliderCircleArrowsProducts === 0
        ? 'transparent'
        : null};
      border-radius: 50%;
    }
    &.item-slider.version-1 {
      .slick-slider {
        margin-left: 0%;
        margin-right: -15%;
      }
      .slick-slider > .slick-arrow {
        top: 34%;
      }
      .slick-slider > .slick-arrow.slick-prev {
        left: -0.5%;
      }
      .slick-slider > .slick-arrow.slick-next {
        right: 17%;
      }
      .slick-slider > .product {
        @media screen and (max-width: 768px) {
          margin: 0px 10px;
        }
      }
    }
  `;

  const settings = {
    arrows: true,
    dots: false,
    prevArrow: <SlickArrowCircleSecondary secondaryColor={secondaryColor} />,
    nextArrow: <SlickArrowCircleSecondary secondaryColor={secondaryColor} />,
    customPaging: function(i) {
      return <button className="dot">{/* {i + 1} */}</button>;
    },
    infinite: false,
    speed: 500,
    rows: 1,
    slidesToShow: parentName ? 6 : 7,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 2100,
        settings: {
          slidesToShow: parentName ? 5 : 6,
        },
      },
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: parentName ? 4 : 5,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: parentName ? 3 : 4,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: parentName ? 2 : 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: parentName ? 2 : 3,
          centerMode: parentName ? true : false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: parentName ? 1 : 2,
        },
      },
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '10%',
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '10%',
        },
      },
    ],
  };

  const settingsInfiniteToTheRight = {
    ...settings,
    slidesToShow: 6,
    slidesToScroll: 6,
    rows: 1,
  };

  const renderItemSlider = () => {
    return (
      <div>
        <div
          className={'show-desktop'}
          style={{
            paddingLeft: productsCarouselVersion === 2 && '3%',
            paddingRight: productsCarouselVersion === 2 && '3%',
            width: '94vw',
          }}
        >
          {renderItemSliderDesktop()}
        </div>
      </div>
    );
  };

  const renderItemSliderDesktop = () => {
    return (
      <div
        className={`item-slider version-${productsCarouselVersion}`}
        css={productArrowsVariants}
      >
        {loading && (
          <div className="loading-slider">
            <FaSpinner className="pulse" /> Caricamento...
          </div>
        )}

        {productsCarouselVersion === 1 ? (
          <Slider {...settingsInfiniteToTheRight}>{children}</Slider>
        ) : (
          <Slider {...settings}>{children}</Slider>
        )}
      </div>
    );
  };

  // const renderItemSliderMobile = () => {
  //   if (fullWidth) {
  //     return (
  //       <div className="item-slider" css={productArrowsVariants}>
  //         {loading && (
  //           <div className="loading-slider">
  //             <FaSpinner className="pulse" /> Caricamento...
  //           </div>
  //         )}

  //         <Slider>{children}</Slider>
  //       </div>
  //     );
  //   }
  //   return (
  //     <div>
  //       <div
  //         style={{
  //           display: 'flex',
  //           flexWrap: 'nowrap',
  //           flexDirection: 'row',
  //           justifyContent: 'flex-start',
  //           maxWidth: '100vw',
  //           // overflow: 'scroll',
  //           marginTop: 8,
  //           paddingTop: 24,
  //         }}
  //       >
  //         {children}
  //       </div>
  //     </div>
  //   );
  // };

  return <div>{renderItemSlider()}</div>;
};

export default ItemSlider;
